import { Screen } from '~/screens/LoginReport';

export const LoginReport: React.FC = () => <Screen />;
